import Vue from "vue";
import Component from "./TransferAccount.vue";
const Constructor = Vue.extend(Component);
let setp = 1;
const TransferAccountModal = options => {
  if (Vue.prototype.$isServer) return;
  const { ...rest } = options;
  const instance = new Constructor({
    propsData: {
      ...rest,
    },
  });

  const id = `TransferAccountModal_${setp}`;
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  // instance.vm.visible = true;
  setp++;

  //绑定
  instance.vm.$on("submit", res => {
    if (instance.submit) {
      instance.submit(res);
    }
  });
  instance.vm.$on("cancel", selecteds => {
    if (instance.cancel) {
      instance.cancel(selecteds);
    }
  });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};
export default TransferAccountModal;
